import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';

export async function getExtrasSummary(data = {}) {
  return getAPIResponse('/v1/extras/summary', data);
}